import { IconChevronBottomOutlined, IconChevronTopOutlined } from '@repo/monochrome-icons';
import { type ReactNode, useState } from 'react';
import { formatDate } from '@repo/design-system-kit';
import { useIntl } from 'react-intl';
import type { QuoteVersion } from 'receivable-invoices-js/react/api/models/quote';
import styles from './dropdown.module.css';

interface DropdownProps {
  history: QuoteVersion[];
}

export function Dropdown({ history }: DropdownProps): ReactNode {
  const [isOpen, setIsOpen] = useState(false);

  const { locale, formatMessage } = useIntl();

  return (
    <div className={styles.dropdownContainer} data-test-dropdown>
      <div className={styles.dropdown}>
        <button
          data-test-dropdown-toggle
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          type="button"
        >
          <span>{formatMessage({ id: 'client-portal.history' })}</span>
          {isOpen ? (
            <IconChevronTopOutlined color="var(--content-secondary)" />
          ) : (
            <IconChevronBottomOutlined color="var(--content-secondary)" />
          )}
        </button>
      </div>
      {isOpen ? (
        <ol className={styles.dropdownContent} data-test-dropdown-content>
          {history.map(({ pdfUrl, id, createdAt }) => (
            <li key={id}>
              <a
                className={styles.dropdownDownloadButton}
                href={pdfUrl}
                rel="noopener noreferrer"
                target="_blank"
              >
                {formatMessage(
                  { id: 'client-portal.created-on.quote' },
                  { date: formatDate({ date: createdAt, locale, token: 'date-year-s' }) }
                )}
              </a>
            </li>
          ))}
        </ol>
      ) : null}
    </div>
  );
}
